module.exports = __webpack_public_path__ + "img/icon-shouye.62d50588.png";